import "./footer.css";
import { useState } from "react";
import privacyPdf from "../../assets/Legal-pdfs/Dwellora-Privacy-Policy.pdf";
import helpPdf from "../../assets/Legal-pdfs/Dwellora-Help-and-Support.pdf";
import cookiesPdf from "../../assets/Legal-pdfs/Dwellora-Cookies-Policy.pdf";
import creditsPdf from "../../assets/Legal-pdfs/Dwellora-Credits.pdf";

const LEGAL_LINKS = [
  { href: privacyPdf, label: "Privacy" },
  { href: helpPdf, label: "Help" },
  { href: cookiesPdf, label: "Cookies policy" },
  { href: creditsPdf, label: "Credits" },
];

const FOOTER_FAQS = [
  {
    question: "Who is the founder of Dwellora Designs?",
    answer:
      "Ar. Gajanan V. Shetkar is the founder of Dwellora Designs and a COA-registered architect with over 10 years of professional experience.",
  },
  {
    question: "Is Dwellora Designs   a government-registered company?",
    answer:
      "Yes. Dwellora Designs operates under Dwellora Designs LLP, a legally registered Limited Liability Partnership with the Ministry of Corporate Affairs (ROC), Government of India.",
  },
  {
    question: "What is Dwellora Designs?",
    answer:
      "Dwellora Designs is a design-led company providing turnkey solutions, bringing design, product expertise and execution together to deliver complete projects.",
  },
];

export default function Footer() {
  const year = new Date().getFullYear();
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq((prev) => (prev === index ? null : index));
  };

  const openContact = () => {
    window.dispatchEvent(new CustomEvent("dwellora:open-contact"));
  };

  return (
    <footer className="site-footer">
      <div className="site-footer-wrap">
        <div className="site-footer-faq">
          <div className="site-footer-faq-left">
            <h2 className="site-footer-faq-title">Frequently Asked Questions</h2>
            <p className="site-footer-faq-desc">
              Have questions about our projects, process, or services? Explore
              our FAQs to get quick and simple answers.
            </p>
          </div>

          <div className="site-footer-faq-right">
            {FOOTER_FAQS.map((faq, index) => (
              <div
                className={`site-footer-faq-item ${openFaq === index ? "is-open" : ""}`}
                key={faq.question}
              >
                <button
                  type="button"
                  className="site-footer-faq-question"
                  onClick={() => toggleFaq(index)}
                  aria-expanded={openFaq === index}
                >
                  <span>{faq.question}</span>
                  <span className="site-footer-faq-icon" aria-hidden="true">
                    {openFaq === index ? "−" : "+"}
                  </span>
                </button>
                {openFaq === index && (
                  <p className="site-footer-faq-answer">{faq.answer}</p>
                )}
              </div>
            ))}

            <a href="/faqs" className="site-footer-faq-cta">
              <span>View All FAQs</span>
              <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>

        <div className="site-footer-top">
          <div>
            <a href="/" className="site-footer-brand" aria-label="Dwellora Livings home">
              Dwellora Designs
            </a>
            <p className="site-footer-subtitle">A Venture by Dwellora Designs LLP</p>
          </div>

          {/* <div className="site-footer-statement-row">
            <p className="site-footer-statement">Get in touch with us for details.</p>
            <a href="/contact" className="site-footer-cta">
              <span>Start a project</span>
              <span aria-hidden="true">-&gt;</span>
            </a>
          </div> */}
        </div>

        <div className="site-footer-grid">
          <div className="site-footer-col">
            <p className="site-footer-label">Address</p>
            <div className="site-footer-info">
              <div className="site-footer-info-item site-footer-info-item--address">
                <span className="site-footer-info-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                    <path d="M12 21s7-6.1 7-11.5A7 7 0 0 0 5 9.5C5 14.9 12 21 12 21Z" />
                    <circle cx="12" cy="9.5" r="2.4" />
                  </svg>
                </span>
                <p className="site-footer-address">
                  Office: 601, The Stellar Complex, Bhumkar Das Gugre Rd, Wakad,
                  Pimpri-Chinchwad, Maharashtra Pincode : 411057
                </p>
              </div>
            </div>
          </div>

          <nav className="site-footer-col" aria-label="Footer navigation">
            <p className="site-footer-label">Explore</p>
            <div className="site-footer-links">
              <a href="/">Home</a>
              <a href="/projects">Projects</a>
              <a href="/how-we-work">How We Work</a>
              <a href="/specialists">Specialists</a>
              <a href="/contact">Contact</a>
               <a href="/faqs">FAQ</a>
            </div>
          </nav>

          <div className="site-footer-col">
            <p className="site-footer-label">Services</p>
            <div className="site-footer-links">
              <button type="button" className="site-footer-service-link" onClick={openContact}>
                Architecture
              </button>
              <button type="button" className="site-footer-service-link" onClick={openContact}>
                Interior Design
              </button>
              <button type="button" className="site-footer-service-link" onClick={openContact}>
                Turnkey Design
              </button>
            </div>
          </div>

          <div className="site-footer-col">
            <div className="site-footer-contact-block">
              <p className="site-footer-label">Contact Us</p>
              <div className="site-footer-info">
                <a
                  href="tel:+919158914222"
                  className="site-footer-info-item site-footer-info-link"
                >
                  <span className="site-footer-info-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                      <path d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.4c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8Z" />
                    </svg>
                  </span>
                  <span>+91 91589 14222</span>
                </a>

                <a
                  href="mailto:contact@dwellorahomes.com"
                  className="site-footer-info-item site-footer-info-link"
                >
                  <span className="site-footer-info-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                      <rect x="3" y="5" width="18" height="14" rx="2.5" />
                      <path d="M4 6.5 12 13l8-6.5" />
                    </svg>
                  </span>
                  <span>contact@dwellorahomes.com</span>
                </a>
              </div>
            </div>
          </div>

          <div className="site-footer-col site-footer-col--follow">
            <div className="site-footer-follow-block">
              <p className="site-footer-label">Follow Us</p>
              <div className="site-footer-social">
                <a
                  href="https://www.instagram.com/dwellora.designs?utm_source=qr"
                  aria-label="Instagram"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                    <rect x="3" y="3" width="18" height="18" rx="5" />
                    <circle cx="12" cy="12" r="4" />
                    <circle cx="17.2" cy="6.8" r="0.9" fill="currentColor" stroke="none" />
                  </svg>
                </a>
                {/* <a
                  href="https://linkedin.com/company/dwellora-design-llp"
                  aria-label="LinkedIn"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                    <rect x="3" y="3" width="18" height="18" rx="2.5" />
                    <line x1="7.5" y1="10" x2="7.5" y2="16.5" />
                    <circle cx="7.5" cy="7" r="0.9" fill="currentColor" stroke="none" />
                    <path d="M11.5 16.5V12.6c0-1.4 1-2.5 2.4-2.5s2.1 1 2.1 2.5v3.9" />
                  </svg>
                </a>
                <a
                  href="https://facebook.com/dwelloraliving"
                  aria-label="Facebook"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                    <path d="M14.5 20v-6.6h2.2l.3-2.6h-2.5V9.1c0-.75.2-1.26 1.28-1.26H17V5.5c-.23-.03-1-.1-1.9-.1-1.9 0-3.2 1.16-3.2 3.3v1.84H9.7v2.6h2.2V20" />
                  </svg>
                </a> */}
              </div>
            </div>
          </div>
        </div>

        <div className="site-footer-bottom">
          <div className="site-footer-legal">
            {LEGAL_LINKS.map((link) => (
              <a href={link.href} key={link.href} target="_blank" rel="noreferrer">
                {link.label}
              </a>
            ))}
          </div>
          <span>© {year} Dwellora Design LLP all rights reserved</span>
        </div>
      </div>
    </footer>
  );
}